export enum CotizacionEstado {
  Anulada,
  Borrador,
  Enviada,
  Vencida,
  Rechazada,
  Aprobada,
}

export const colorMapping: { [key in CotizacionEstado]: string } = {
  [CotizacionEstado.Anulada]: 'black',
  [CotizacionEstado.Aprobada]: '#22c55e',
  [CotizacionEstado.Rechazada]: '#FF0000',
  [CotizacionEstado.Borrador]: '#70BDFF',
  [CotizacionEstado.Enviada]: 'orange',
  [CotizacionEstado.Vencida]: '#008000',
};

export const CotizacionEstadoLabels: { [key in CotizacionEstado]: string } = {
  [CotizacionEstado.Anulada]: 'Anulada',
  [CotizacionEstado.Borrador]: 'Borrador',
  [CotizacionEstado.Enviada]: 'Enviada',
  [CotizacionEstado.Vencida]: 'Vencida',
  [CotizacionEstado.Rechazada]: 'Rechazada',
  [CotizacionEstado.Aprobada]: 'Aprobada',
};

export const getCotizacionEstado = () => {
  return Object.values(CotizacionEstado)
    .filter((value) => typeof value === 'number')
    .map((id) => ({
      id,
      text: CotizacionEstadoLabels[id as CotizacionEstado],
    }));
};
